export enum OrderTypeEnum{
    STOCK='STOCK',
    PRODUCTION='PRODUCTION'
}